import { ICommonTranslations } from '@/translations/default/common';

const common: Partial<ICommonTranslations> = {
  product_interactions: 'Interações com produtos',
};

export default common;
